<div class="jw-modal">
  <div class="jw-modal-body">
    <ng-content></ng-content>
  </div>
</div>
